module.exports = __webpack_public_path__ + "assets/img/7@3x.f5d8618b.png";